import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
  LEGACY_SCREEN_VIEW,
  URL_SCREEN_NO,
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "./PriceEdgeSequenceScheduleFormConfig";
import { LegacyResolvers } from "../../common_nextgen/utils/UtilFunctions";

const screenInfo = {
  ADD: ["Add Price Edge Schedule Sequence", "RCPED002"],
  CHANGE: ["Price Edge Schedule Sequence Detail", "RCPED003"],
  VIEW: ["Price Edge Schedule Sequence Detail", "RCPED003"],
};

const PriceEdgeSequenceScheduleForm = ({ mode }) => {
  const location = useLocation();
  const navigateToPage = useCustomNavigate();
  const { axios_helper_no_header } = useAxios();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    selectedSteps = [],
    previousScreen = ROUTE_PATHS.MAX_COPAY_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    hasInactiveRecords = false,
    externalMode: initialExternalMode = false,
  } = currentState;
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();

  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const [externalMode, setExternalMode] = useState(initialExternalMode);

  const handleReceiveData = (data) => {
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

  const fetchParamData = async (
    formData,
    apiFieldInputs,
    apiFieldMapping,
    screenNumber
  ) => {
    const queryParams = apiFieldInputs.reduce((acc, item) => {
      acc[item["target"]] = formData[item["source"]];
      return acc;
    }, {});
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `${URL_SCREEN_NO[screenNumber]}`,
        null,
        queryParams
      );

      const response = raw_response.responseData;
      if (response) {
        if (response && Object.keys(response).length) {
          const mappedData = apiFieldMapping.reduce((mappedObj, mapping) => {
            mappedObj[mapping["legacy"]] = response[mapping["source"]];
            return mappedObj;
          }, {});
          console.log("Mapped Data:", mappedData);
          return mappedData;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const viewLookupDetails = async (lookupScreen, params, formData) => {
    const {
      viewType,
      fieldMapping,
      apiFetch,
      apiFieldMapping,
      apiFieldInputs,
    } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      let apiParamData = {};
      if (apiFetch) {
        const { default: screenNumber } = lookupScreen;
        apiParamData = await fetchParamData(
          formData,
          apiFieldInputs,
          apiFieldMapping,
          screenNumber
        );
        console.log(apiParamData, "apiParamData");
      }
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: params.extraParam
          ? {
              ...paramData,
              carCarrierId: formData?.pedCarrierId,
              wrkCarrierName: formData?.pedCarrierName,
            }
          : apiFetch
          ? apiParamData
          : paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };

  const handleBack = () => {
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      if (hasInactiveRecords) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: "Cannot edit inactive record.",
          life: 3000,
        });
      }
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitFormData = (data) => {
    setDataForSubmission(data);
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";

    if (isAddMode(currentMode)) {
      url = "api/pedPriceEdgeSchDtl";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/pedPriceEdgeSchDtl";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        toast.current.show({
          severity: "info",
          summary: "",
          detail: "No Change of Information",
          life: 3000,
        });
        return;
      }
    }

    const data = { ...dataForSubmission, screenNumber };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      setInitialFormData({
        ...responseData,
        pesScheduleName: selectedSchedules[0].pesScheduleName,
        pesScheduleDescription:
          selectedSchedules[0].pesScheduleDescription,
      });
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const updatedCurrentState = {
          ...currentState,
          selectedSchedules: [
            {
              ...responseData,
              pesScheduleDescription:
                selectedSchedules[0].pesScheduleDescription,
            },
          ],
          selectedSteps: [{ ...responseData }],
          currentIndex: 0,
        };

        const updatedPreviousState = previousState.map((stateObj) => {
          if (stateObj.paramsData) {
            return {
              ...stateObj,
              paramsData: {
                ...stateObj.paramsData,
                pedScheduleSeq: responseData?.pedScheduleSeq,
              },
            };
          }
          return stateObj;
        });
        
        navigateToPage(ROUTE_PATHS.EDIT_PRICE_EDGE_SCHEDULE_SEQUENCE, [
          ...updatedPreviousState,  
          updatedCurrentState,
        ]);

        const paramsData = {
          pedScheduleSeq: responseData.pedScheduleSeq,
          pedSeq: responseData.pedSeq,
        };

        const fetchInitialData = async () => {
          const url = `api/pedPriceEdgeSchDtl/${encodeURIComponent(
            selectedSchedules[0].pesScheduleName
          )}`;
          const { responseUpdatedData } = await axios_helper_no_header(
            "GET",
            url,
            null,
            paramsData
          );
          setInitialFormData({
            ...responseUpdatedData,
            pesScheduleName: selectedSchedules[0].pesScheduleName,
            pesScheduleDescription:
              selectedSchedules[0].pesScheduleDescription,
          });
        };

        fetchInitialData();
      }
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      if (!externalMode){
        keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        keyName.chmod = "Edit";
      }
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex,initialFormData]);

  useEffect(() => {
    const paramsData = {
      pedScheduleSeq: selectedSteps[currentIndex].pedScheduleSeq,
      pedSeq: selectedSteps[currentIndex].pedSeq,
    };
    const fetchInitialData = async () => {
      try {
        const url = isAddMode(currentMode)
          ? `api/pedPriceEdgeSchDtl/initialFormData/${screenInfo.ADD[1]}`
          : `api/pedPriceEdgeSchDtl/${encodeURIComponent(
              selectedSchedules[0].pesScheduleName
            )}`;
        const { responseData } = await axios_helper_no_header(
          "GET",
          url,
          null,
          paramsData
        );
        setInitialFormData({
          ...responseData,
          pesScheduleName: selectedSchedules[0].pesScheduleName,
          pesScheduleDescription:
            selectedSchedules[0].pesScheduleDescription,
        });
      } catch (e) {
        console.error(e);
      }
    };
    fetchInitialData();
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default PriceEdgeSequenceScheduleForm;